let lastScrollY = 0;

window.addEventListener('scroll', () => {
  const header = document.querySelector('.home-header:not(.template-header)');
  const scrollY = window.scrollY;
  const isDesktop = window.innerWidth >= 1024;

  if (isDesktop) {
    if (scrollY <= 20) {
      header?.classList.remove('active-scroll');
      header?.classList.remove('active-scroll-up');
    } else if (scrollY > lastScrollY) {
      header?.classList.add('active-scroll');
      header?.classList.remove('active-scroll-up');
    } else if (scrollY < lastScrollY) {
      header?.classList.remove('active-scroll');
      header?.classList.add('active-scroll-up');
    }
  } else {
    if (scrollY > 1) {
      header?.classList.add('active-scroll');
    } else {
      header?.classList.remove('active-scroll');
    }
  }

  lastScrollY = scrollY <= 0 ? 0 : scrollY;
});



document.addEventListener('DOMContentLoaded', function () {
  const openMenuBtn = document.getElementById('open_menu');
  const header = document.querySelector('header');
  const body = document.body;
  const menuLinks = document.querySelectorAll('.menu-lv1');
  if (openMenuBtn && header) {
    openMenuBtn.addEventListener('click', function () {
      header.classList.toggle('is-menu-show');
    });
  }
  if (window.innerWidth < 1024) {
    menuLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const parentItem = this.closest('.menu-item');
        if (!parentItem) return;
        parentItem.classList.toggle('active');
      });
    });
  }
});
document.addEventListener("DOMContentLoaded", () => {

  function initMarquee() {
    new Swiper(".marquee-row1", {
      direction: "vertical",
      slidesPerView: "auto",
      loop: true,
      speed: 9000,
      allowTouchMove: false,
      freeMode: true,
      freeModeMomentum: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
      }
    });


    new Swiper(".marquee-row2", {
      direction: "vertical",
      slidesPerView: "auto",
      loop: true,
      speed: 12000,
      allowTouchMove: false,
      freeMode: true,
      freeModeMomentum: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: true,
      }
    });
    new Swiper(".marquee-row3", {
      direction: "vertical",
      slidesPerView: "auto",
      loop: true,
      speed: 9000,
      allowTouchMove: false,
      freeMode: true,
      freeModeMomentum: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
      }
    });
  }
  let started = false;

  const target = document.querySelector("#converting");
  if (!target) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !started) {
        started = true;
        initMarquee();
        observer.disconnect();
      }
    });
  }, {
    threshold: 0.2
  });

  observer.observe(target);
});
document.addEventListener('DOMContentLoaded', () => {
  const searchButton = document.querySelector('.header-search button');
  const searchOverlay = document.querySelector('#templateSearch');
  const bgOverlay = document.querySelector('.bg-search-overlay');
  const closeButton = searchOverlay?.querySelector('.close-button');
  const input = document.getElementById('q');
  const resultsContainer = document.getElementById('smartResults');

  let templates = [];

  function levenshteinDistance(s1, s2) {
    if (s1.length < s2.length) [s1, s2] = [s2, s1];
    if (s2.length === 0) return s1.length;
    let prevRow = Array.from({ length: s2.length + 1 }, (_, i) => i);
    for (let i = 0; i < s1.length; i++) {
      let currRow = [i + 1];
      for (let j = 0; j < s2.length; j++) {
        let substitutions = prevRow[j] + (s1[i] === s2[j] ? 0 : 1);
        currRow.push(Math.min(prevRow[j + 1] + 1, currRow[j] + 1, substitutions));
      }
      prevRow = currRow;
    }
    return prevRow[s2.length];
  }

  fetch('/products.json?limit=999')
  .then(res => res.json())
  .then(data => {
    templates = data.products.map(p => ({
      title: p.title,
      link: p.handle,
      image: (p.images && p.images.length > 0) ? p.images[0].src : 'https://via.placeholder.com/50',
      type: (p.product_type || "").toLowerCase(),
      tags: p.tags, 
      created_at: p.created_at
    }));
  });

  const renderResults = () => {
    const query = input.value.toLowerCase().trim();
    resultsContainer.innerHTML = '';

    if (query === '' || templates.length === 0) {
      resultsContainer.classList.add('hidden');
      return;
    }

    const searchTerms = query.split(/\s+/).filter(t => t.length > 0);

    let filtered = templates.filter(t => {
      const titleWords = t.title.toLowerCase().split(/\s+/);
      const typeWords = t.type.split(/\s+/);
      const allWords = [...titleWords, ...typeWords];

      return searchTerms.every(term => {
        return allWords.some(word => {
          if (word.includes(term)) return true;
          if (term.length > 3) {
            return levenshteinDistance(term, word) <= 1;
          }
          return false;
        });
      });
    });

  filtered.sort((a, b) => {
    const q = query.toLowerCase();
    const aTitle = a.title.toLowerCase();
    const bTitle = b.title.toLowerCase();

    if (aTitle === q && bTitle !== q) return -1;
    if (bTitle === q && aTitle !== q) return 1;

    const aStarts = aTitle.startsWith(q) ? 1 : 0;
    const bStarts = bTitle.startsWith(q) ? 1 : 0;
    if (aStarts !== bStarts) return bStarts - aStarts;

    const getPriority = (item) => {
      if (!item.tags) return 0;
      if (item.tags.includes("Recommend")) return 3;
      if (item.tags.includes("Trending")) return 2;
      if (item.tags.includes("Featured")) return 1;
      return 0;
    };

    const priorityDiff = getPriority(b) - getPriority(a);
    if (priorityDiff !== 0) return priorityDiff;

    return aTitle.localeCompare(bTitle);
  });
    const displayItems = filtered.slice(0, 5);

    if (displayItems.length === 0) {
      resultsContainer.innerHTML = `<li class="px-4 py-6 text-center text-gray-500">No templates found</li>`;
    } else {
      displayItems.forEach(t => {
        const li = document.createElement('li');
        li.className = "px-4 py-3 hover:bg-gray-100 border-b font-semibold text-bm";
        li.innerHTML = `
          <a href="/pages/templates/${t.link}" class="flex items-center gap-3">
            <img src="${t.image}" alt="${t.title}" class="w-12 h-12 object-cover rounded">
            <span>${t.title}</span>
          </a>`;
        resultsContainer.appendChild(li);
      });

      const viewAllLi = document.createElement('li');
      viewAllLi.className = "px-4 py-3 mt-4 text-center eb-button-primary cursor-pointer font-medium w-full flex justify-center text-white bg-black rounded-lg";
      viewAllLi.textContent = "View All Results";
      viewAllLi.onclick = () => window.location.href = `/pages/templates?q=${encodeURIComponent(query)}`;
      resultsContainer.appendChild(viewAllLi);
    }
    resultsContainer.classList.remove('hidden');
  };

  /* ==========================================
     4. EVENT LISTENERS
     ========================================== */
  input?.addEventListener('input', renderResults);

  searchButton?.addEventListener('click', (e) => {
    e.stopPropagation();
    searchOverlay?.classList.remove('hidden', 'opacity-0');
    searchOverlay?.classList.add('opacity-100');
    bgOverlay?.classList.remove('hidden');
    setTimeout(() => input?.focus(), 100);
  });

  const closeSearch = () => {
    searchOverlay?.classList.add('opacity-0');
    setTimeout(() => searchOverlay?.classList.add('hidden'), 200);
    bgOverlay?.classList.add('hidden');
  };

  bgOverlay?.addEventListener('click', closeSearch);
  closeButton?.addEventListener('click', closeSearch);

  input?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      window.location.href = `/pages/templates?q=${encodeURIComponent(input.value.trim())}`;
    }
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('backToTop');
  if (!btn) return;

  const circle = btn.querySelector('circle');
  if (!circle) return;

  const RADIUS = 48;
  const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
  const SHOW_OFFSET = 300;

  circle.style.strokeDasharray = CIRCUMFERENCE;
  circle.style.strokeDashoffset = CIRCUMFERENCE;

  let progress = 0;

  const update = () => {
    const scrollTop = window.scrollY;
    const maxScroll =
      document.documentElement.scrollHeight - window.innerHeight;

    /* show / hide */
    if (scrollTop > SHOW_OFFSET) {
      btn.classList.add('show');
    } else {
      btn.classList.remove('show');
    }

    /* progress 0 → 1 */
    progress = maxScroll > 0
      ? Math.min(scrollTop / maxScroll, 1)
      : 0;

    render();
  };

  const render = () => {
    circle.style.strokeDashoffset =
      CIRCUMFERENCE * (1 - progress);
  };

  window.addEventListener('scroll', update);
  update();

  btn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach(link => {
    link.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").substring(1);
      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        e.preventDefault();
        const topPos = targetEl.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({
          top: topPos,
          behavior: "smooth"
        });
      }
    });
  });
});
